import { render } from "./TheNotificationBottomArea.vue?vue&type=template&id=2337d501&scoped=true&ts=true"
import script from "./TheNotificationBottomArea.vue?vue&type=script&lang=ts"
export * from "./TheNotificationBottomArea.vue?vue&type=script&lang=ts"

import "./TheNotificationBottomArea.vue?vue&type=style&index=0&id=2337d501&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2337d501"]])

export default __exports__